import React from 'react';
import { useSelector } from 'react-redux';

import { getStudents, getSchoolCode } from 'common.components/classes/selectors';
import { StudentsPrint } from 'common.components/students-print/students-print';
import { getUsePassportAccountsFromSearchString } from 'utils/get-passport';
import { getTeamIdFromPath } from 'utils/path';

export const TeamInvitationContainer = () => {
    const classId = getTeamIdFromPath();
    const usePassportAccounts = getUsePassportAccountsFromSearchString();

    const students = useSelector((store) => getStudents(store, { classId }));
    const schoolCode = useSelector((store) => getSchoolCode(store, { classId }));

    return (
        <StudentsPrint
            schoolCode={schoolCode}
            shouldShowParentInvitation={true}
            shouldUsePassportAccounts={usePassportAccounts}
            students={students}
        />
    );
};
